// EN / FR strings
export const translations = {
  en: {
    nav: {
      services: "Services",
      cities: "Cities",
      about: "About",
      insights: "Insights",
      contact: "Contact",
      quote: "Request Quote",
      case_studies: "Case Studies",
    },
    common: {
      lang_toggle: "FR",
      request_quote: "Contact Us",
      learn_more: "Learn more",
      view_service: "View service",
      view_city: "View city",
      back: "Back",
      all_services: "All Services",
      all_cities: "All Cities",
      quebec_wide: "Quebec-wide coverage",
      licensed: "BSP Licensed",
      bilingual: "Bilingual FR / EN",
      response_247: "24/7 response",
      copyright: "© Quebec Security Services. All rights reserved.",
      certifications: "BSP Licensed · CNESST Compliant · Bilingual · 24/7",
    },
    home: {
      hero_kicker: "Quebec-Wide · BSP Licensed · Since 2011",
      h1: "Security guard services in Quebec",
      hero_line1: "Absolute",
      hero_line2: "protection.",
      hero_line3: "Province-wide.",
      hero_sub: "Bilingual, uniformed, BSP-licensed security professionals safeguarding Quebec's businesses, mines, events, and residences — from Montreal to Fermont.",
      manifesto_kicker: "The Manifesto",
      chapter_01_title: "Vetted",
      chapter_01_body: "Every officer clears an RCMP background check, BSP licensing verification, and a psychological fitness screen before touching a post.",
      chapter_02_title: "Vigilant",
      chapter_02_body: "60+ hours of pre-deployment training. Use-of-force scaling, de-escalation, first-aid, radio protocol, and site-specific onboarding.",
      chapter_03_title: "Visible",
      chapter_03_body: "Uniformed presence. Marked patrol vehicles. Live GPS tracking. Every checkpoint, geo-stamped and audit-ready.",
      chapter_04_title: "Verified",
      chapter_04_body: "Every incident logged. Every shift reported. Every promise, provable — through the Quebec Security Services client portal.",
      services_kicker: "Our Services",
      services_title: "A protection spectrum",
      services_sub: "From lobby concierge to remote mining perimeter — a single, accountable partner across every discipline.",
      cities_kicker: "Coverage",
      cities_title: "Every city. Every hour.",
      cities_sub: "Rapid deployment across all Quebec regions.",
      case_kicker: "In the field",
      case_title: "Real operations. Real results.",
      cta_title: "Ready to raise your standard?",
      cta_sub: "Tell us about the site. We'll build the plan.",
    },
    meta: {
      home_title: "Quebec Security Guards & Mobile Patrols | Maze Security",
      home_desc: "Explore guard, patrol and site security services in Quebec, Montreal and across the province. Ask about coverage and a site-specific security plan.",
      home_keywords: "security guard Quebec, mobile patrol Quebec, security services Montreal, security company Quebec, site security Quebec, BSP licensed security guards",
      services_title: "24 Security Guard Services in Quebec | Static, Mobile, Mining, Event | Maze Security",
      services_desc: "24 professional security guard services across Quebec — static guards, mobile patrol, mining site security, event security, executive protection, K9 detection, alarm response, construction site, corporate, residential, cash-in-transit and more. BSP licensed, bilingual FR/EN, 24/7 dispatch.",
      services_keywords: "security guard services Quebec, security company Quebec, security firm Montreal, security services Laval, security agency Quebec City, agent de sécurité Québec, BSP licensed security, bilingual security Quebec",
      about_title: "About Maze Security | Licensed Bilingual Security Firm Quebec",
      about_desc: "Since 2011, Maze Security delivers BSP-licensed bilingual security to Quebec's businesses, mines, events, and residences. 17 regions. 1,240+ officers. 24/7 command.",
      contact_title: "Contact Maze Security — (807) 907-2874",
      contact_desc: "Contact Maze Security (Quebec Security Services). Phone: (807) 907-2874. Email: info@mazesecurity.ca. Bilingual FR/EN, 24/7 command centre, BSP licensed.",
      seo_index_title: "Every Security Search Term — Quebec Coverage | Maze Security",
      seo_index_desc: "A complete directory of security guard services across Quebec — service × city combinations, intent keywords, and industry-vertical pages. Find your exact operating need.",
    },
    services: {
      list_title: "Every service. One accountable partner.",
      list_sub: "Twenty-four disciplines under one BSP-licensed roof — from static concierge to mining perimeter and cash-in-transit.",
      detail_overview: "Overview",
      detail_keywords: "Related expertise",
      detail_cta: "Deploy this service",
    },
    cities: {
      list_title: "Quebec, city by city.",
      list_sub: "From Montreal skyscrapers to Fermont mining outposts — locally deployed, provincially accountable.",
      detail_intro: "Security guard services in",
      detail_deploy: "Deployed in",
    },
    about: {
      title: "The company. The commitment.",
      body: "Quebec Security Services is a bilingual, BSP-licensed security firm serving the entire province of Quebec. We operate from strategic staging points across Montreal, Laval, Quebec City, Sherbrooke, Trois-Rivières, Gatineau, Val-d'Or and Sept-Îles — giving us sub-45-minute deployment reach to every incorporated municipality in Quebec.",
    },
    quote: {
      title: "Request a tailored quote",
      sub: "Four steps. Zero pressure. Reply within one business day.",
      step: "Step",
      of: "of",
      next: "Continue",
      prev: "Back",
      submit: "Send request",
      submitted_title: "Received.",
      submitted_body: "Your request is in our command centre. A security consultant will reply within one business day.",
    },
    contact: {
      title: "Talk to command.",
      sub: "Send us the details. We'll take it from there — no phone tag, no email chains.",
    },
    footer: {
      cta_line1: "Quebec Security",
      cta_line2: "Services",
      sitemap_services: "Services",
      sitemap_cities: "Cities",
      sitemap_company: "Company",
      sitemap_legal: "Legal",
      newsletter: "Ops briefing",
      newsletter_sub: "One tactical update per month. No spam. Unsubscribe anytime.",
      subscribe: "Subscribe",
    },
  },
  fr: {
    nav: {
      services: "Services",
      cities: "Villes",
      about: "À propos",
      insights: "Analyses",
      contact: "Contact",
      quote: "Demander une soumission",
      case_studies: "Études de cas",
    },
    common: {
      lang_toggle: "EN",
      request_quote: "Nous contacter",
      learn_more: "En savoir plus",
      view_service: "Voir le service",
      view_city: "Voir la ville",
      back: "Retour",
      all_services: "Tous les services",
      all_cities: "Toutes les villes",
      quebec_wide: "Couverture provinciale",
      licensed: "Licencié BSP",
      bilingual: "Bilingue FR / EN",
      response_247: "Intervention 24/7",
      copyright: "© Quebec Security Services. Tous droits réservés.",
      certifications: "Licencié BSP · Conforme CNESST · Bilingue · 24/7",
    },
    home: {
      hero_kicker: "Partout au Québec · Licencié BSP · Depuis 2011",
      h1: "Agence de sécurité au Québec",
      hero_line1: "Protection",
      hero_line2: "absolue.",
      hero_line3: "À l'échelle du Québec.",
      hero_sub: "Professionnels de la sécurité bilingues, en uniforme et licenciés BSP, protégeant les entreprises, mines, événements et résidences du Québec — de Montréal à Fermont.",
      manifesto_kicker: "Le Manifeste",
      chapter_01_title: "Vérifié",
      chapter_01_body: "Chaque agent passe une vérification GRC, une validation de licence BSP et un examen psychologique avant tout déploiement.",
      chapter_02_title: "Vigilant",
      chapter_02_body: "Plus de 60 heures de formation pré-déploiement. Recours à la force, désescalade, premiers soins, protocole radio.",
      chapter_03_title: "Visible",
      chapter_03_body: "Présence uniformée. Véhicules identifiés. Suivi GPS en temps réel. Chaque point de contrôle, géolocalisé.",
      chapter_04_title: "Documenté",
      chapter_04_body: "Chaque incident consigné. Chaque quart rapporté. Chaque promesse, prouvable — via notre portail client.",
      services_kicker: "Nos services",
      services_title: "Un éventail de protection",
      services_sub: "Du concierge de hall à un périmètre minier éloigné — un seul partenaire, imputable dans chaque discipline.",
      cities_kicker: "Couverture",
      cities_title: "Chaque ville. Chaque heure.",
      cities_sub: "Déploiement rapide dans toutes les régions du Québec.",
      case_kicker: "Sur le terrain",
      case_title: "Opérations réelles. Résultats réels.",
      cta_title: "Prêt à hausser votre standard ?",
      cta_sub: "Parlez-nous du site. On bâtit le plan.",
    },
    meta: {
      home_title: "Agence de sécurité au Québec | Gardiens et patrouille | Maze Security",
      home_desc: "Agents de sécurité, patrouille mobile et protection de sites à Montréal, Laval, Longueuil et partout au Québec. Demandez un plan adapté à votre site.",
      home_keywords: "agence de sécurité Laval, agence de sécurité Longueuil, compagnie de sécurité Laval, agence de sécurité Terrebonne, agence de sécurité Blainville, agence de sécurité Montréal, gardiens de sécurité Québec",
      services_title: "Services de sécurité au Québec | Gardiens, patrouille et mines | Maze Security",
      services_desc: "Gardiens de sécurité licenciés BSP, patrouille mobile, sécurité minière, sécurité événementielle, protection rapprochée, intervention sur alarme et transport de valeurs — partout au Québec. Bilingue FR/EN, répartition 24/7.",
      services_keywords: "services de sécurité Québec, agence de sécurité Montréal, compagnie de sécurité Québec, gardiens licenciés BSP, patrouille mobile Québec, sécurité minière Québec",
      about_title: "À propos de Maze Security | Firme de sécurité bilingue licenciée au Québec",
      about_desc: "Depuis 2011, Maze Security livre une sécurité bilingue licenciée BSP aux entreprises, mines, événements et résidences du Québec. 17 régions. 1 240+ agents. Commandement 24/7.",
      contact_title: "Contactez Maze Security — (807) 907-2874",
      contact_desc: "Contactez Maze Security (Quebec Security Services). Téléphone : (807) 907-2874. Courriel : info@mazesecurity.ca. Bilingue FR/EN, centre de commandement 24/7, licencié BSP.",
      seo_index_title: "Toutes les recherches en sécurité — Couverture Québec | Maze Security",
      seo_index_desc: "Un répertoire complet des services de sécurité au Québec — combinaisons service × ville, requêtes d'intention et pages par industrie. Trouvez votre besoin exact.",
    },
    services: {
      list_title: "Chaque service. Un partenaire imputable.",
      list_sub: "Vingt-quatre disciplines sous un même toit licencié BSP — du concierge à la sécurité minière.",
      detail_overview: "Aperçu",
      detail_keywords: "Expertise connexe",
      detail_cta: "Déployer ce service",
    },
    cities: {
      list_title: "Le Québec, ville par ville.",
      list_sub: "Des gratte-ciels de Montréal aux avant-postes miniers de Fermont — déployés localement, imputables provincialement.",
      detail_intro: "Services d'agents de sécurité à",
      detail_deploy: "Déployé à",
    },
    about: {
      title: "L'entreprise. L'engagement.",
      body: "Quebec Security Services est une firme de sécurité bilingue et licenciée BSP desservant l'ensemble du Québec. Nous opérons à partir de points stratégiques à Montréal, Laval, Québec, Sherbrooke, Trois-Rivières, Gatineau, Val-d'Or et Sept-Îles.",
    },
    quote: {
      title: "Demander une soumission sur mesure",
      sub: "Quatre étapes. Aucune pression. Réponse en un jour ouvrable.",
      step: "Étape",
      of: "de",
      next: "Continuer",
      prev: "Retour",
      submit: "Envoyer",
      submitted_title: "Reçu.",
      submitted_body: "Votre demande est au centre de commandement. Un consultant répondra en un jour ouvrable.",
    },
    contact: {
      title: "Parlez au centre de commandement.",
      sub: "Envoyez-nous les détails. Nous prenons le relais.",
    },
    footer: {
      cta_line1: "Quebec Security",
      cta_line2: "Services",
      sitemap_services: "Services",
      sitemap_cities: "Villes",
      sitemap_company: "Entreprise",
      sitemap_legal: "Légal",
      newsletter: "Bulletin ops",
      newsletter_sub: "Une mise à jour tactique par mois. Aucun pourriel.",
      subscribe: "S'abonner",
    },
  },
};
